import { render, staticRenderFns } from "./ui-tile.vue?vue&type=template&id=d1b042fa&scoped=true&"
import script from "./ui-tile.vue?vue&type=script&lang=js&"
export * from "./ui-tile.vue?vue&type=script&lang=js&"
import style0 from "./ui-tile.vue?vue&type=style&index=0&id=d1b042fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1b042fa",
  null
  
)

export default component.exports